// import React from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { LockClosedIcon } from '@heroicons/react/20/solid';

// import { useAuth } from "../context/AuthContext";

// function Footer() {
//   const { isAuthenticated, logout } = useAuth();
//   const navigate = useNavigate();

//   const handleLogout = () => {
//     logout();
//     navigate("/admin/login");
//   };

//   return (
//     <footer className="bg-primary text-white py-12 px-6">
//       <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 border-b border-white pb-8">
//         {/* OwenLab Section */}
//         <div>
//           <h3 className="text-lg font-bold mb-3 border-b border-white pb-2">The Owen Lab</h3>
//           <p>Department of Physiology & Pharmacology, Department of Psychology</p>
//           <p>WIRB, Room 6156</p>
//           <p>London, Ontario, Canada, N6A 5B7</p>
//           <p>Tel: 519-661-2111 x84672</p>
//           <p>Email: <a href="mailto:uwocerc@uwo.ca" className="hover:underline">uwocerc@uwo.ca</a></p>
//         </div>

//         {/* Navigation Links */}
//         <div>
//           <ul className="space-y-2">
//             <li><Link to="/Research" className="hover:underline">Research</Link></li>
//             <li><Link to="/Publications" className="hover:underline">Publications</Link></li>
//             <li><Link to="/NewsAndMedia" className="hover:underline">News & Media</Link></li>
//             <li><Link to="/FAQ" className="hover:underline">FAQ</Link></li>
//             <li><Link to="/ContactUs" className="hover:underline">Contact</Link></li>

//             {isAuthenticated ? (
//               <>
//                 <Link
//                   to="/admin"
//                   className="text-lg font-medium text-gray-700 hover:text-accent transition duration-300"
//                 >
//                   <span>Admin Panel</span>
//                 </Link>
//                 <button
//                   onClick={handleLogout}
//                   className="text-lg font-medium text-gray-700 hover:text-red-600 transition duration-300"
//                 >
//                   Logout
//                 </button>
//               </>
//             ) : (
//               <Link
//                 to="/admin/login" lassName="flex items-center space-x-2 text-white hover:text-accent">
//                 <LockClosedIcon className="h-5 w-5 text-white" />
//                 {/* className="text-lg font-medium text-gray-700 hover:text-primary transition duration-300" */}
    
//                 {/* <span className="text-sm">Login</span> */}
//               </Link>
//             )}


//           </ul>
//         </div>
//       </div>

      

//       {/* Footer Bottom */}
//       <div className="flex flex-col md:flex-row justify-between items-center mt-6">
//         <p className="text-sm">© 2025 The Owen Lab</p>
//         <div className="flex space-x-4 mt-4 md:mt-0">
//           <Link to="/privacy" className="text-sm hover:underline">Privacy</Link>
//           <span>•</span>
//           <Link to="/web-standards" className="text-sm hover:underline">Web Standards</Link>
//           <span>•</span>
//           <Link to="/terms-of-use" className="text-sm hover:underline">Terms of Use</Link>
//           <span>•</span>
//           <Link to="/accessibility" className="text-sm hover:underline">Accessibility</Link>
//         </div>
//       </div>
//     </footer>
//   );
// }

// export default Footer;

// import React from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { LockClosedIcon } from '@heroicons/react/20/solid';
// import { useAuth } from "../context/AuthContext";

// function Footer() {
//   const { isAuthenticated, logout } = useAuth();
//   const navigate = useNavigate();

//   const handleLogout = () => {
//     logout();
//     navigate("/admin/login");
//   };

//   return (
//     <footer className="bg-gradient-to-r from-[#003366] to-[#006d66] text-white py-4 px-6">
//       <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
//         {/* OwenLab Section */}
//         <div>
//           <h3 className="text-lg font-bold mb-3">The Owen Lab</h3>
//           <p>Department of Physiology & Pharmacology, Department of Psychology</p>
//           <p>WIRB, Room 6156</p>
//           <p>London, Ontario, Canada, N6A 5B7</p>
//           <p>Tel: 519-661-2111 x84672</p>
//           <p>Email: <a href="mailto:uwocerc@uwo.ca" className="hover:underline">uwocerc@uwo.ca</a></p>
//         </div>

//         {/* Navigation Links */}
//         <div>
//           <ul className="space-y-2">
//             <li><Link to="/Research" className="hover:underline">Research</Link></li>
//             <li><Link to="/Publications" className="hover:underline">Publications</Link></li>
//             <li><Link to="/NewsAndMedia" className="hover:underline">News & Media</Link></li>
//             <li><Link to="/FAQ" className="hover:underline">FAQ</Link></li>
//             <li><Link to="/ContactUs" className="hover:underline">Contact</Link></li>

//             {isAuthenticated ? (
//               <>
//                 <Link
//                   to="/admin"
//                   className="text-lg font-medium text-gray-700 hover:text-accent transition duration-300"
//                 >
//                   Admin Panel
//                 </Link>
//                 <button
//                   onClick={handleLogout}
//                   className="text-lg font-medium text-gray-700 hover:text-red-600 transition duration-300"
//                 >
//                   Logout
//                 </button>
//               </>
//             ) : (
//               <Link
//                 to="/admin/login"
//                 className="flex items-center space-x-2 text-white hover:text-accent"
//               >
//                 <LockClosedIcon className="h-5 w-5 text-white" />
//                 {/* <span className="text-sm">Login</span> */}
//               </Link>
//             )}
//           </ul>
//         </div>
//       </div>

//       {/* Footer Bottom */}
//       <div className="flex flex-col md:flex-row justify-between items-center mt-4">
//         <p className="text-sm">© 2025 The Owen Lab</p>
//       </div>
//     </footer>
//   );
// }

// export default Footer;

// import React from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { LockClosedIcon } from '@heroicons/react/20/solid';
// import { useAuth } from "../context/AuthContext";

// function Footer({ isFullFooter = true }) {
//   const { isAuthenticated, logout } = useAuth();
//   const navigate = useNavigate();

//   const handleLogout = () => {
//     logout();
//     navigate("/admin/login");
//   };

//   return (
//     <footer className="bg-gradient-to-r from-[#003366] to-[#006d66] text-white py-4 px-6">
//       <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
//         {isFullFooter && (
//           <div>
//             {/* OwenLab Section */}
//             <h3 className="text-lg font-bold mb-3">The Owen Lab</h3>
//             <p>Department of Physiology & Pharmacology, Department of Psychology</p>
//             <p>WIRB, Room 6156</p>
//             <p>London, Ontario, Canada, N6A 5B7</p>
//             <p>Tel: 519-661-2111 x84672</p>
//             <p>Email: <a href="mailto:uwocerc@uwo.ca" className="hover:underline">uwocerc@uwo.ca</a></p>
//           </div>
//         )}

//         {/* Navigation Links Section (Only shown on full footer) */}
//         {isFullFooter && (
//           <div>
//             <ul className="space-y-2">
//               <li><Link to="/Research" className="hover:underline">Research</Link></li>
//               <li><Link to="/Publications" className="hover:underline">Publications</Link></li>
//               <li><Link to="/NewsAndMedia" className="hover:underline">News & Media</Link></li>
//               <li><Link to="/FAQ" className="hover:underline">FAQ</Link></li>
//               <li><Link to="/ContactUs" className="hover:underline">Contact</Link></li>

//               {isAuthenticated ? (
//                 <>
//                   <Link
//                     to="/admin"
//                     className="text-lg font-medium text-gray-700 hover:text-accent transition duration-300"
//                   >
//                     Admin Panel
//                   </Link>
//                   <button
//                     onClick={handleLogout}
//                     className="text-lg font-medium text-gray-700 hover:text-red-600 transition duration-300"
//                   >
//                     Logout
//                   </button>
//                 </>
//               ) : (
//                 <Link
//                   to="/admin/login"
//                   className="flex items-center space-x-2 text-white hover:text-accent"
//                 >
//                   <LockClosedIcon className="h-5 w-5 text-white" />
//                 </Link>
//               )}
//             </ul>
//           </div>
//         )}
//       </div>

//       {/* Footer Bottom */}
//       <div className="flex flex-col md:flex-row justify-between items-center mt-4">
//         <p className="text-sm">© 2025 The Owen Lab</p>
//       </div>
//     </footer>
//   );
// }

// export default Footer;

import React from "react";
import { Link } from "react-router-dom";
import { LockClosedIcon } from '@heroicons/react/20/solid';

function Footer({ isFullFooter = true }) {
  return (
    <footer className="bg-gradient-to-r from-[#003366] to-[#006d66] text-white py-4 px-6">
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        {/* Full Footer (For home page) */}
        {isFullFooter && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* OwenLab Section */}
            <div>
              <h3 className="text-lg font-bold mb-3">The Owen Lab</h3>
              <p>Department of Physiology & Pharmacology, Department of Psychology</p>
              <p>WIRB, Room 6156</p>
              <p>London, Ontario, Canada, N6A 5B7</p>
              <p>Tel: 519-661-2111 x84672</p>
              <p>Email: <a href="mailto:OwenLab@uwo.ca" className="hover:underline">OwenLab@uwo.ca</a></p>
            </div>

            {/* Navigation Links Section */}
            <div>
              <ul className="space-y-2">
                <li><Link to="/Research" className="hover:underline">Research</Link></li>
                <li><Link to="/Publications" className="hover:underline">Publications</Link></li>
                <li><Link to="/Media" className="hover:underline">Media</Link></li>
                {/* <li><Link to="/FAQ" className="hover:underline">FAQ</Link></li> */}
                <li><Link to="/ContactUs" className="hover:underline">Contact</Link></li>
                <li><Link to="/books" className="hover:underline">Books</Link></li>
                <li>
                  <Link
                    to="/admin/login"
                    className="flex items-center space-x-2 text-white hover:text-accent"
                  >
                    <LockClosedIcon className="h-5 w-5 text-white" />
                    <span className="text-sm">Login</span>
                  </Link>
                </li>
              </ul>
            </div>
          </div> 
        )}

        {/* Footer Bottom (Now, only on Full Footer) */}
        {isFullFooter && (
          <div className="flex justify-between items-center mt-4">
            <p className="text-sm">© 2025 The Owen Lab</p>
          </div>
        )}
      </div>

      

        {/* Smaller Footer (For non-home pages like Research, Publications, etc.) */}
        {!isFullFooter && (
          <div className="flex justify-between items-center w-full">
            <p className="text-sm">© 2025 The Owen Lab</p>
            <Link
              to="/admin/login"
              className="flex items-center space-x-2 text-white hover:text-accent"
            >
              <LockClosedIcon className="h-5 w-5 text-white" />
              <span className="text-sm">Login</span>
            </Link>
          </div>
        )}
      {/* </div> */}

      
    </footer>
  );
}

export default Footer;











